/**
 * Get `[width, height]` integer dimensions which fit one rectangle to the
 * given max, preserving aspect ratio and scaling either up or down. Mode
 * 'contain' letterboxes the content, and in contrast 'cover' clips content at
 * it's smaller edge then allows the other to exceed the container's max.
 */
export function getScaledDimensions(maxWidth, maxHeight, naturalWidth, naturalHeight) {
  var fitMode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'contain';
  var aspectWidth = maxWidth / naturalWidth;
  var aspectHeight = maxHeight / naturalHeight;
  var scale = fitMode === 'contain' ? Math.min(aspectWidth, aspectHeight) : Math.max(aspectWidth, aspectHeight);
  return [Math.round(naturalWidth * scale), Math.round(naturalHeight * scale)];
}